import { typography } from '@shared/tokens/typography.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  pagination: {
    display: 'flex',
    alignItems: 'center',
    gap: anatomy['size-8'],
    fontFamily: fonts.din2014Regular,
  },
  button: {
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    margin: 0,
    display: 'flex',
    alignItems: 'center',
  },
  paginationArrow: {
    padding: `${anatomy['size-4']}`,
    cursor: 'pointer',
    ':disabled': {
      cursor: 'default',
      opacity: 0.5,
    },
  },
  paginationArrowLeft: {
    transform: 'rotate(180deg)',
  },
  paginationItem: {
    color: colors.primaryText,
    width: anatomy['size-24'],
    height: anatomy['size-24'],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: typography['fontSizeCaption-2'],
    lineHeight: typography['lineHeightCaption-2'],
    userSelect: 'none',
    ':disabled': {
      cursor: 'default',
      opacity: 0.5,
    },
  },
  paginationItemActive: {
    color: colors.accentText,
    border: `1px solid ${colors.accentBorder} !important`,
    borderRadius: anatomy['size-4'],
  },
});
